import EmailButtonFieldsConfig from "segments/desktop/core-components/button/email-button/fields-config";

export default {
  ...EmailButtonFieldsConfig
};
